declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '1255955049925181'
let pixelInitialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined' || pixelInitialized) return
  pixelInitialized = true

  // Initialize fbq
  const f = window
  const b = document
  const e = 'script'

  const n: any = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  // Init pixel and queue PageView immediately (works with fbq queue)
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Fire ViewContent AFTER fbevents.js has fully loaded
  t.onload = () => {
    window.fbq('track', 'ViewContent', {
      content_name: 'El Interruptor del Sueño +40',
      content_type: 'product',
      content_ids: ['interruptor-sueno-40'],
      value: 114,
      currency: 'MXN',
    })
  }

  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  // Add noscript fallback pixel in body
  const noscriptImg = b.createElement('img')
  noscriptImg.height = 1
  noscriptImg.width = 1
  noscriptImg.style.display = 'none'
  noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  b.body.appendChild(noscriptImg)
}

/**
 * Fires AddToCart on CTA click.
 * NOTE: InitiateCheckout and Purchase are handled by Shopify to avoid duplicity.
 */
export function trackCTAClick() {
  if (typeof window === 'undefined' || !window.fbq) return

  window.fbq('track', 'AddToCart', {
    content_name: 'El Interruptor del Sueño +40',
    content_type: 'product',
    content_ids: ['interruptor-sueno-40'],
    value: 114,
    currency: 'MXN',
  })
}
